import { Component, OnInit, Input, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { RestApiService } from "../../shared/rest-api.service";
import { Title } from "@angular/platform-browser";

declare let $: any;

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.css']
})
export class PricingComponent implements OnInit {

	public packages: any;
	//public ppackages: any;
	interval : any;
	constructor(
		public restApi: RestApiService, 
		public router: Router,
		public ngZone: NgZone,
		private titleService:Title
	) {
		this.titleService.setTitle("Pricing");
	}

	ngOnInit(): void {
		// this.getPackages();
		// $.getScript('assets/scripts/slick.js', function(){});
		// setTimeout(function () {
			// let jsScript = document.createElement("script");
			// jsScript.type = "text/javascript";
			// jsScript.async = true;
			// jsScript.innerHTML  = "$(document).ready(function () {  $('.slider').slick({ autoplay: false, dots: false, infinite: false, arrows: true, slidesToShow: 3, slidesToScroll: 3, rows: 0, responsive: [{ breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3, infinite: true, dots: true } }, {  breakpoint: 600,  settings: {  slidesToShow: 2, slidesToScroll: 2 } }, { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } } ] }).on('setPosition', function (event, slick) { slick.$slides.css('height', slick.$slideTrack.height() + 'px'); });});";
			// document.body.appendChild(jsScript); 
		// },400);
	}
	
	getPackages(): void {
		this.restApi.getPackages()
		  .subscribe(
			packages => {
			  this.packages = packages;
			  console.log(packages);
			},
			error => {
			  console.log(error);
			});
	}
	
/* 	getPPackages(): void {
		this.restApi.getPPackages()
		  .subscribe(
			ppackages => {
				this.ppackages = ppackages;
				console.log(ppackages);
			},
			error => {
			  console.log(error);
			});
	} */
	
	ngAfterViewInit(): void {
		/* this.interval = setInterval(() => {
			let jsScript = document.createElement("script");
			jsScript.type = "text/javascript";
			jsScript.async = true;
			jsScript.innerHTML  = "$(document).ready(function () { $('.owl-carousel').owlCarousel({ mouseDrag: false, loop: true, margin: 2, nav: true, responsive: { 0: { items: 1 }, 600: { items: 1 }, 1000: { items: 3 } } }); $('.owl-prev').click(function () { $active = $('.owl-item .item.show'); $('.owl-item .item.show').removeClass('show'); $('.owl-item .item').removeClass('next');$('.owl-item .item').removeClass('prev');$active.addClass('next');if ($active.is('.first')) {$('.owl-item .last').addClass('show');$('.first').addClass('next');$('.owl-item .last').parent().prev().children('.item').addClass('prev');} else {$active.parent().prev().children('.item').addClass('show');if ($active.parent().prev().children('.item').is('.first')) {$('.owl-item .last').addClass('prev');} else {$('.owl-item .show').parent().prev().children('.item').addClass('prev');}}});$('.owl-next').click(function () {$active = $('.owl-item .item.show');$('.owl-item .item.show').removeClass('show');$('.owl-item .item').removeClass('next');$('.owl-item .item').removeClass('prev');$active.addClass('prev');if ($active.is('.last')) {$('.owl-item .first').addClass('show');$('.owl-item .first').parent().next().children('.item').addClass('prev');} else {$active.parent().next().children('.item').addClass('show');if ($active.parent().next().children('.item').is('.last')) {$('.owl-item .first').addClass('next');} else {$('.owl-item .show').parent().next().children('.item').addClass('next');}}}); });";
			document.body.appendChild(jsScript);
			clearInterval(this.interval);
		},500)
	*/

		setTimeout(function () {
			$.getScript('assets/scripts/jquery-3.3.1.js', function(){});
			let jsScript = document.createElement("script");
			jsScript.type = "text/javascript";
			jsScript.async = true;
			jsScript.innerHTML  = "$(document).ready(function () { $('.grecaptcha-badge').hide(); });";
			document.body.appendChild(jsScript); 
		},400);

	}
}
